// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__34wr7","title":"Header_title__1uDfi","side":"Header_side__nxq8G"};